export const theme = {
  background: {
    default: 'rgb(128, 0, 128)',
    secondary: 'rgba(237, 235, 242, 0.862)',
    dark: 'rgb(0, 0, 0)',
  },
  color: {
    default: '#fff',
    secondary: 'rgba(237, 235, 242, 0.862)',
  },
  lightGray: 'rgb(237, 237, 237)',
  midGray: 'rgb(153, 153, 153)',
  darkGray: 'rgb(68, 68, 68)',
};
